import React from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import "../styles/NavBar.css";

class NavBar extends React.Component {
  render() {
    return (
      <Navbar fixed="top" className="bg-body-tertiary">
        <Container>
          <Navbar.Brand href="#">Shy</Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link href="#intro">Home</Nav.Link>
              <Nav.Link href="#about">About</Nav.Link>
              <Nav.Link href="#media">Media</Nav.Link>
              <Nav.Link href="#favorite-gifs">Favorite GIFs</Nav.Link>
            </Nav>
            {/*
            <Nav className="ml-auto">
              <Nav.Link href="https://letterboxd.com/shymovies/" target="_blank" rel="noopener noreferrer">
                <SiLetterboxd style={{ fontSize: 21 }}>Letterboxd</SiLetterboxd>
              </Nav.Link>
              <Nav.Link href="https://github.com/new-cmd" target="_blank">
                <GitHubIcon style={{ fontSize: 19 }}></GitHubIcon>
              </Nav.Link>
              <Nav.Link href="https://steamcommunity.com/id/_shy/" target="_blank" rel="noopener noreferrer">
                <FaSteam style={{ fontSize: 20 }} />
              </Nav.Link>
            </Nav>
            */}
          </Navbar.Collapse>
        </Container>
      </Navbar>
    );
  }
}

export default NavBar;
